export const status = ["paid", "pending", "overdue"];
export default status;
